import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StdSystemCodeImportWithAddComponent } from './std-system-code-import-with-add/std-system-code-import-with-add.component';
import { SharedModule } from '../../shared.module';
import { SystemCodeListGridViewComponent } from './system-code-list-grid-view/system-code-list-grid-view.component';
import { SystemCodeAddComponent } from './system-code-add/system-code-add.component';
import { StdSystemCodeImportComponent } from './std-system-code-import/std-system-code-import.component';
import { SystemCodeEditerComponent } from './system-code-editer/system-code-editer.component';



@NgModule({
  declarations: [
    StdSystemCodeImportWithAddComponent,
    SystemCodeListGridViewComponent,
    SystemCodeAddComponent,
    StdSystemCodeImportComponent,
  SystemCodeEditerComponent],
  exports:[
    StdSystemCodeImportWithAddComponent,
    SystemCodeListGridViewComponent,
    SystemCodeAddComponent,
    StdSystemCodeImportComponent,
    SystemCodeEditerComponent],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class VisSystemCodeModule { }
